import * as React from "react";
import { useCallback } from "react";
import { useField } from "formik";
import { MultiSelect } from "components/common";
import { ControlLabel } from "components/bootstrap";
import { Col } from "security-app/components/common/FormBaseStyles";
import { ErrorMessage } from "./ErrorMessage";
function FormikMultiSelect({ field, options, label = void 0, disabled = false, multiple = false }) {
  const [{ name, value }, { touched, error }, { setValue, setTouched }] = useField({ name: field.name, multiple });
  const onChange = useCallback(
    (newValue) => {
      setValue(newValue.split(","));
    },
    [setValue]
  );
  const selectValue = Array.isArray(value) ? value.join(",") : value;
  return /* @__PURE__ */ React.createElement(Col, { $fullWidth: true, $width: "100%", $gap: "0.3rem", $align: "stretch" }, label && /* @__PURE__ */ React.createElement(ControlLabel, null, label), /* @__PURE__ */ React.createElement(
    MultiSelect,
    {
      id: name,
      inputProps: { "aria-label": name },
      name,
      onChange,
      onBlur: () => setTouched(true),
      value: selectValue,
      disabled,
      options,
      menuPlacement: "bottom"
    }
  ), touched && error && /* @__PURE__ */ React.createElement(ErrorMessage, null, error));
}
export default FormikMultiSelect;
